/* =========================================================
 *  DZIENNIK BLEDOW (24.09.2026, docs/dziennik-bledow-audytorow.md)
 *
 *  Dyspozycja Marcina: kazdy wyjatek ma dac klientowi polski komunikat i wpis
 *  w dzienniku do analizy zbiorczej. Wpis idzie beaconem do api.php (log_client),
 *  serwer dopisuje czas, sesje (skrot) i przegladarke. NIGDY nie wysylamy adresu
 *  e-mail, nazwy firmy ani tresci formularza. Bledy, ktore serwer odeslal jako
 *  status error, serwer zapisal juz sam, wiec tu logujemy tylko to, czego serwer
 *  nie widzi: zerwane polaczenie, limit czasu, zla odpowiedz, wyjatki JS.
 * ========================================================= */
const DZIENNIK_URL = '/wp-content/themes/audytor/api.php';
const DZIENNIK_MAX = 30; // na odslone strony; serwer ma wlasny limit 30/sesje/h
let dziennikLicznik = 0;
const dziennikBylo = {};

function tokenZAdresu() {
    try {
        const r = new URLSearchParams(window.location.search).get('r');
        return r && /^[a-f0-9]{32}$/.test(r) ? r : '';
    } catch (e) {
        return '';
    }
}

export function zglosBlad(wpis) {
    try {
        const klucz = [wpis.etap, wpis.typ, wpis.komunikat].join('|');
        if (dziennikLicznik >= DZIENNIK_MAX || dziennikBylo[klucz]) return;
        dziennikBylo[klucz] = true;
        dziennikLicznik++;
        const tresc = JSON.stringify({
            action: 'log_client',
            etap: String(wpis.etap || 'nieznany').slice(0, 60),
            typ: String(wpis.typ || 'inny').slice(0, 40),
            komunikat: String(wpis.komunikat || '').slice(0, 500),
            komunikat_klienta: wpis.komunikat_klienta ? String(wpis.komunikat_klienta).slice(0, 300) : '',
            kod: wpis.kod === undefined ? null : wpis.kod,
            token: tokenZAdresu()
        });
        if (navigator.sendBeacon && navigator.sendBeacon(DZIENNIK_URL, new Blob([tresc], { type: 'application/json' }))) return;
        fetch(DZIENNIK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: tresc,
            keepalive: true,
            credentials: 'same-origin'
        }).catch(() => { /* dziennik nie moze psuc strony */ });
    } catch (e) { /* dziennik nie moze psuc strony */ }
}

/** Typ, kod i techniczny opis bledu do dziennika. */
function opiszBlad(e) {
    if (!e) return { typ: 'inny', kod: null, komunikat: 'pusty blad' };
    const nazwa = e.name || 'Error';
    const tekst = nazwa + ': ' + (e.message || String(e));
    if (nazwa === 'AbortError' || nazwa === 'TimeoutError') return { typ: 'timeout', kod: null, komunikat: tekst };
    if (nazwa === 'HttpError') return { typ: e.status >= 500 ? 'http_5xx' : 'http_4xx', kod: e.status, komunikat: tekst };
    if (nazwa === 'ZlaOdpowiedz') return { typ: 'zla_odpowiedz', kod: e.status || null, komunikat: tekst };
    if (e instanceof TypeError && /fetch|network|load failed/i.test(e.message || '')) return { typ: 'siec', kod: null, komunikat: tekst };
    const ramka = (e.stack || '').split('\n').find((l) => /\.js/.test(l)) || '';
    return { typ: 'wyjatek_js', kod: null, komunikat: tekst + (ramka ? ' @ ' + ramka.trim().slice(0, 150) : '') };
}

/** Polski komunikat dla klienta; nigdy surowy tekst przegladarki. */
function komunikatBledu(e, tekstLimituCzasu) {
    const typ = opiszBlad(e).typ;
    if (typ === 'timeout') return tekstLimituCzasu || 'Serwer odpowiada dłużej niż zwykle i przekroczyliśmy limit czasu. Spróbuj ponownie.';
    if (typ === 'http_5xx' || typ === 'http_4xx' || typ === 'zla_odpowiedz') return 'Serwer chwilowo nie odpowiada poprawnie. Spróbuj ponownie za kilka minut, a jeśli błąd się powtórzy, napisz na marcin@avangardo.pl.';
    if (typ === 'siec') return 'Wystąpił błąd połączenia. Sprawdź połączenie z internetem i spróbuj ponownie.';
    return 'Coś poszło nie tak po naszej stronie. Odśwież stronę i spróbuj ponownie, a jeśli błąd się powtórzy, napisz na marcin@avangardo.pl.';
}

/** Zapis do dziennika + komunikat dla klienta w jednym kroku. Zwraca komunikat. */
function obsluzBlad(etap, e, tekstLimituCzasu) {
    const komunikat = komunikatBledu(e, tekstLimituCzasu);
    zglosBlad(Object.assign({ etap: etap, komunikat_klienta: komunikat }, opiszBlad(e)));
    return komunikat;
}

let dziennikGlobalny = false;
function zainstalujDziennikGlobalny() {
    if (dziennikGlobalny) return;
    dziennikGlobalny = true;
    window.addEventListener('error', (ev) => {
        // "Script error." to blad skryptu z innej domeny (piksel, GTM) bez szczegolow:
        // nic z niego nie wyczytamy, a zjadalby limit wpisow.
        if (!ev || !ev.message || ev.message === 'Script error.') return;
        const plik = String(ev.filename || '').split('?')[0].split('/').pop();
        zglosBlad({ etap: 'window.onerror', typ: 'wyjatek_js', komunikat: ev.message + ' @ ' + plik + ':' + (ev.lineno || 0) + ':' + (ev.colno || 0) });
    });
    window.addEventListener('unhandledrejection', (ev) => {
        const powod = ev && ev.reason;
        const opis = powod instanceof Error ? opiszBlad(powod) : { typ: 'wyjatek_js', kod: null, komunikat: 'unhandledrejection: ' + String(powod).slice(0, 300) };
        zglosBlad(Object.assign({ etap: 'unhandledrejection' }, opis));
    });
}

export function audytor() {
    zainstalujDziennikGlobalny();

    const form = document.getElementById('analyzeForm');
    if (!form) return; // formularz tylko na stronie glownej (mainsite.php)

    // Warstwa danych jak w obu audytorach. Bez tych trzech zdarzen regula
    // "Konwersja lead magnetu" we wspolnym kontenerze Audytor nie ma sie o co
    // zaczepic i Radar raportowal do GA4 same odslony (stan do 23.08.2026).
    function pushDL(name, params) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params || {}));
    }

    // Blad piksela Meta nie moze przerwac badania ani zamienic udanej wysylki raportu
    // w komunikat o bledzie (wczesniej wyjatek z fbq wpadal w catch formularza).
    function zdarzenieMeta(nazwa, params) {
        try {
            if (typeof fbq === 'function') fbq('track', nazwa, params);
        } catch (e) {
            zglosBlad(Object.assign({ etap: 'fbq.' + nazwa }, opiszBlad(e)));
        }
    }

    let progress = 0;
    const preloader = document.querySelector('.preloader');
    const preloaderData = document.querySelector('.preloader__data');
    const resultsContainer = document.getElementById('test_results');

    const API_URL = 'wp-content/themes/audytor/api.php';

    // Fetch z twardym timeoutem (wzorzec audytora GMB). Checki DataForSEO
    // (zwlaszcza ChatGPT z web search) potrafia trwac do ~2 min - dlugie timeouty.
    async function apiCall(payload, timeoutMs = 45000) {
        const ctrl = new AbortController();
        const timer = window.setTimeout(() => ctrl.abort(), timeoutMs);
        try {
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                signal: ctrl.signal
            });
            // Serwer odpowiada JSON-em takze przy bledzie 500 (polski komunikat z dziennik.php),
            // wiec poprawny JSON oddajemy zawsze. Strona bledu bramki (502, 504, 524
            // Cloudflare) albo ucieta odpowiedz to osobny, nazwany blad z kodem HTTP.
            const tekst = await response.text();
            try {
                return JSON.parse(tekst);
            } catch (e) {
                const blad = new Error((response.ok ? 'odpowiedz nie jest JSON' : 'HTTP ' + response.status) + ' przy ' + payload.action + ': ' + tekst.slice(0, 120).replace(/\s+/g, ' '));
                blad.name = response.ok ? 'ZlaOdpowiedz' : 'HttpError';
                blad.status = response.status;
                throw blad;
            }
        } finally {
            window.clearTimeout(timer);
        }
    }

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        try {
            await badaj();
        } catch (e) {
            showFatalError(obsluzBlad('badanie', e));
        }
    });

    async function badaj() {
        const firmName = document.getElementById('firmName').value.trim();
        const firmDomain = document.getElementById('firmDomain').value.trim();
        const firmDesc = document.getElementById('firmDesc').value.trim();
        const firmPhrase = document.getElementById('firmPhrase').value.trim();

        if (firmName.length < 2) {
            displayError('Podaj nazwę firmy');
            return;
        }
        if (firmDomain.length < 4) {
            displayError('Podaj adres strony WWW firmy (np. mojafirma.pl)');
            return;
        }
        if (firmDesc.length < 10) {
            displayError('Opisz krótko, czym zajmuje się firma (np. "biuro rachunkowe dla e-commerce, Poznań")');
            return;
        }
        clearError();

        // Meta Pixel: start badania to ViewContent, NIE Lead. Lead w slowniku Meta
        // znaczy "zostawil dane kontaktowe" i pada dopiero przy bramce z adresem
        // (poprawione 23.08.2026 - wczesniej algorytm uczylby sie sciagac klikaczy).
        zdarzenieMeta('ViewContent', { content_name: firmName, content_category: 'radar_ai' });
        pushDL('audit_requested', { audit_query: firmName });

        document.querySelector('.app').classList.add('show');
        document.querySelector('body').classList.add('showMenu');
        document.getElementById('siteUrl2').textContent = firmName;

        resultsContainer.classList.add('active');
        preloader.classList.add('active');
        setAppHeader('Sprawdzam widoczność w AI', 'Teraz wykonuję:');
        showStepMessage('Zapisuję dane firmy...');
        updatePreloaderData(4, 400);

        // Krok 1: dane firmy
        let resolveData;
        try {
            resolveData = await apiCall({
                action: 'resolve_firm',
                firm_name: firmName,
                firm_domain: firmDomain,
                firm_desc: firmDesc,
                firm_phrase: firmPhrase
            }, 30000);
        } catch (e) {
            showFatalError(obsluzBlad('resolve_firm', e));
            return;
        }
        if (resolveData.status === 'error_alert') {
            showAlertError(resolveData.message);
            return;
        }
        if (resolveData.status !== 'ok') {
            showFatalError(resolveData.message || 'Nie udało się zapisać danych firmy.');
            return;
        }

        // Krok 2: dobor fraz przez AI
        showStepMessage('Dobieram pytania, które Twoi klienci zadają AI...');
        updatePreloaderData(10, 800);

        let queriesData;
        try {
            queriesData = await apiCall({ action: 'generate_queries' }, 60000);
        } catch (e) {
            showFatalError(obsluzBlad('generate_queries', e,
                'Dobieranie fraz trwa dłużej niż zwykle i przekroczyliśmy limit czasu. Wróć i spróbuj ponownie.'));
            return;
        }
        if (queriesData.status === 'error_alert') {
            showAlertError(queriesData.message);
            return;
        }
        if (queriesData.status !== 'ok' || !queriesData.data || !queriesData.data.queries) {
            showFatalError(queriesData.message || 'Nie udało się dobrać fraz.');
            return;
        }

        showQueries(queriesData.data.queries);
        updatePreloaderData(16, 600);

        // Krok 3: sekwencja checkow AI
        const actions = [
            { name: 'check_aio', description: 'Sprawdzam przeglądy AI w Google (AI Overview)...', timeout: 180000 },
            { name: 'check_chatgpt', description: 'Pytam ChatGPT tak, jak zapytałby Twój klient...', timeout: 200000 },
            { name: 'check_perplexity', description: 'Sprawdzam odpowiedzi i cytowania w Perplexity...', timeout: 180000 },
            { name: 'get_summary', description: 'Liczę wynik i przygotowuję podsumowanie...', timeout: 45000 }
        ];

        progress = 16;
        const progressIncrement = 84 / actions.length;

        for (const action of actions) {
            showStepMessage(action.description);

            let data;
            try {
                data = await apiCall({ action: action.name }, action.timeout);
            } catch (e) {
                showFatalError(obsluzBlad(action.name, e,
                    'Badanie trwa dłużej niż zwykle i przekroczyliśmy limit czasu. Wróć i spróbuj ponownie.'));
                return;
            }

            if (data.status === 'ok') {
                progress += progressIncrement;
                updatePreloaderData(progress, 1000);
                if (action.name === 'get_summary') {
                    showResults(data);
                    udostepnijWynik();
                    return;
                }
            } else if (data.status === 'error_alert') {
                showAlertError(data.message);
                return;
            } else {
                // Odmowe z komunikatem serwer zapisal juz w dzienniku sam.
                showFatalError(data.message || 'Wystąpił błąd podczas badania. Spróbuj ponownie.');
                return;
            }
        }
    }

    function showQueries(queries) {
        const holder = document.createElement('div');
        holder.classList.add('radar-queries');

        const title = document.createElement('span');
        title.classList.add('radar-queries__title');
        title.textContent = 'Pytania, które sprawdzam:';
        holder.appendChild(title);

        queries.forEach((q) => {
            const chip = document.createElement('span');
            chip.classList.add('radar-queries__chip');
            if (q.source === 'user') chip.classList.add('radar-queries__chip--user');
            chip.textContent = q.text;
            holder.appendChild(chip);
        });

        resultsContainer.appendChild(holder);
    }

    function setAppHeader(title, label) {
        document.querySelector('.app__testinfoContent h2').textContent = title;
        const stepLabel = document.getElementById('stepLabel');
        if (stepLabel) stepLabel.textContent = label;
    }

    function showStepMessage(text) {
        const messageElement = document.createElement('div');
        messageElement.textContent = text;
        messageElement.classList.add('result-message');
        const previousMessages = resultsContainer.querySelectorAll('.result-message');
        previousMessages.forEach(message => message.classList.add('hide'));
        resultsContainer.appendChild(messageElement);
        window.setTimeout(() => {
            messageElement.classList.add('show');
        }, 100);
    }

    function showFatalError(message) {
        // Wlasny blok (position: static) - .result-message jest absolute i
        // przycisk powrotu nakladal sie na tekst komunikatu
        resultsContainer.querySelectorAll('.result-message').forEach(m => {
            m.classList.add('hide');
            m.classList.remove('show');
        });
        document.querySelector('.app__header').classList.add('stepCandidates');
        setAppHeader('Nie udało się', '');

        const holder = document.createElement('div');
        holder.classList.add('fatal-error');

        const text = document.createElement('p');
        text.classList.add('fatal-error__text');
        text.textContent = message;
        holder.appendChild(text);

        const back = document.createElement('button');
        back.type = 'button';
        back.classList.add('fatal-error__back');
        back.textContent = 'Wróć i spróbuj ponownie';
        back.addEventListener('click', () => {
            document.querySelector('.app').classList.remove('show');
            document.querySelector('body').classList.remove('showMenu');
            resetAppState();
        });
        holder.appendChild(back);
        resultsContainer.appendChild(holder);
    }

    function showAlertError(message) {
        document.querySelector('.app').classList.remove('show');
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('error-alert');
        errorMessage.textContent = message;
        document.querySelector('.subpageHeader__text').appendChild(errorMessage);
    }

    function resetAppState() {
        progress = 0;
        preloader.classList.remove('active');
        preloaderData.textContent = '0%';
        resultsContainer.classList.remove('active');
        resultsContainer.querySelectorAll('.result-message, .radar-queries, .fatal-error').forEach(el => el.remove());
        const finallyEl = document.querySelector('.app__finally');
        if (finallyEl) finallyEl.remove();
        document.querySelector('.app__header').classList.remove('step2', 'stepCandidates');
        setAppHeader('Sprawdzam widoczność w AI', 'Teraz wykonuję:');
    }

    /**
     * Odnosnik do tego wyniku (dyspozycja Marcina 24.09.2026): po badaniu serwer
     * zapisuje wynik pod tokenem, a my wpisujemy go w pasek adresu. Adres mozna
     * dodac do zakladek albo wyslac komus i otworzyc bez ponownego, platnego badania.
     */
    function udostepnijWynik() {
        apiCall({ action: 'share_report' }, 15000)
            .then((d) => {
                const token = d && d.data && d.data.token;
                if (!token || !/^[a-f0-9]{32}$/.test(token)) return;
                try {
                    window.history.replaceState(null, '', window.location.pathname + '?r=' + token);
                } catch (e) {
                    zglosBlad(Object.assign({ etap: 'share_report.replaceState' }, opiszBlad(e)));
                }
            })
            // Brak odnosnika nie psuje ekranu wyniku, klient niczego nie traci: bez komunikatu.
            .catch((e) => zglosBlad(Object.assign({ etap: 'share_report' }, opiszBlad(e))));
    }

    /** Wejscie z odnosnika ?r=<token>: wynik z zapisu, zero zapytan do AI. */
    async function wczytajRaport(token) {
        document.querySelector('.app').classList.add('show');
        document.querySelector('body').classList.add('showMenu');
        resultsContainer.classList.add('active');
        preloader.classList.add('active');
        setAppHeader('Wczytuję zapisany raport', '');
        updatePreloaderData(30, 400);

        const odmowa = (message) => {
            document.querySelector('.app').classList.remove('show');
            document.querySelector('body').classList.remove('showMenu');
            resetAppState();
            // Zly odnosnik zdejmujemy z paska, zeby odswiezenie nie powtarzalo bledu.
            try {
                window.history.replaceState(null, '', window.location.pathname);
            } catch (e) {
                zglosBlad(Object.assign({ etap: 'load_report.replaceState' }, opiszBlad(e)));
            }
            showAlertError(message);
        };

        if (!/^[a-f0-9]{32}$/.test(token)) {
            odmowa('Ten odnośnik do raportu jest nieprawidłowy. Sprawdź, czy został skopiowany w całości.');
            return;
        }

        let raport;
        let podsumowanie;
        try {
            raport = await apiCall({ action: 'load_report', token: token }, 20000);
            if (!raport || raport.status !== 'ok') {
                odmowa((raport && raport.message) || 'Nie udało się wczytać raportu.');
                return;
            }
            document.getElementById('siteUrl2').textContent = raport.data.name || '';
            updatePreloaderData(70, 300);
            podsumowanie = await apiCall({ action: 'get_summary' }, 20000);
        } catch (e) {
            odmowa(obsluzBlad('load_report', e));
            return;
        }
        if (!podsumowanie || podsumowanie.status !== 'ok') {
            odmowa((podsumowanie && podsumowanie.message) || 'Nie udało się wczytać raportu.');
            return;
        }
        updatePreloaderData(100, 200);
        try {
            showResults(podsumowanie, raport.data.date || '');
        } catch (e) {
            odmowa(obsluzBlad('load_report.showResults', e));
        }
    }

    function showResults(data, dataBadania) {
        document.querySelector('.app__header').classList.add('step2');
        // Wynik z odnosnika mowi, z kiedy jest: odpowiedzi AI zmieniaja sie z czasem.
        document.querySelector('.app__testinfoContent h2').textContent = dataBadania
            ? 'Badanie z dnia ' + dataBadania
            : 'Badanie zakończone';
        // Tytul h2 jest w stanie wyniku ukryty (naglowek: etykieta + nazwa firmy),
        // wiec date pokazujemy jako dopisek pod nazwa firmy (decyzja Marcina 24.09.2026).
        const siteName = document.getElementById('siteUrl2');
        let dataEl = document.querySelector('.radar-data-badania');
        if (dataBadania) {
            if (!dataEl) {
                dataEl = document.createElement('span');
                dataEl.classList.add('radar-data-badania');
                siteName.insertAdjacentElement('afterend', dataEl);
            }
            dataEl.textContent = 'Badanie z dnia ' + dataBadania;
        } else if (dataEl) {
            dataEl.remove();
        }

        // Otwarcie zapisanego raportu to nie jest ukonczone badanie - nie pompujemy lejka.
        pushDL(dataBadania ? 'report_opened' : 'audit_completed', {
            audit_query: document.getElementById('siteUrl2').textContent
        });

        const results = document.createElement('div');
        results.classList.add('app__finally');
        results.innerHTML = data.data;

        document.querySelector('.app__content').appendChild(results);
        addEmailForm();

        const scroll_to_form = document.querySelector('.app__gotoform');
        if (scroll_to_form) {
            scroll_to_form.addEventListener('click', () => {
                jQuery('.app').animate({ 'scrollTop': (jQuery('#emailForm').offset().top) + 'px' }, 500);
            });
        }
    }

    function addEmailForm() {
        const emailForm = document.createElement('div');
        emailForm.classList.add('finally-results__form');

        emailForm.innerHTML = `
            <h3 class="finally-results__intro">Odbierz pełny raport PDF</h3>
            <p class="finally-results__intro">Pobierz pełny raport zawierający wyniki wszystkich sprawdzeń, pogłębioną analizę AI i plan poprawek przygotowany dla Twojej strony.</p>
            <form id="emailForm">
                <div class="emailForm__form">
                    <div class="form-group">
                        <input type="email" id="userEmail" placeholder="Twój adres email" >
                        <div class="error-msg"></div>
                    </div>
                    <div class="form-group checkbox-group">
                        <input type="checkbox" id="rodoConsent" >
                        <label for="rodoConsent"><span>

    Akceptuję <a href="https://radar.avangardo.pl/regulamin-uslugi/" target="_blank">Regulamin usługi radar.avangardo.pl</a> i wyrażam zgodę na otrzymywanie od "Avangardo sp. z o.o." treści marketingowych i informacji handlowych, dotyczących produktów i usług "Avangardo sp. z o.o." poprzez kontakt e-mailowy. Możesz nie podawać danych do kontaktu handlowego i marketingowego i uzyskać raport w kwocie 99 zł. W tym celu napisz do nas na marcin@avangardo.pl.

    <span class="rodo-hidden-element">Administratorem Twoich danych osobowych jest „Avangardo spółka z o.o.", z siedzibą w Szczecinie 70-655, przy ul. Wendy 10 lok. 3C, wpisaną do Krajowego Rejestru Sądowego pod numerem KRS: 0000942472, REGON: 520784536, NIP: 8513268189. Możesz wycofać zgodę w dowolnym momencie, kierując informację na marcin@avangardo.pl. Wycofanie zgody nie wpływa na zgodność z prawem działań podjętych na podstawie zgody przed jej wycofaniem. Więcej w <a href="https://radar.avangardo.pl/polityka-prywatnosci/" target="_blank">polityce prywatnosci</a>.</span>
                        <a class="rodo-hidden-element-trigger">Rozwiń więcej</a>

                        </span>

                        </label>
                        <div class="error-msg"></div>
                    </div>
                <button type="submit" class="btn mainBtn">Odbieram bezpłatny raport</button>
                </div>
                <div class="emailForm__generator"></div>
            </form>

        `;

        document.querySelector('.finally-results').appendChild(emailForm);

        const emailFormElement = document.getElementById('emailForm');
        const emailInput = document.getElementById('userEmail');
        const rodoConsent = document.getElementById('rodoConsent');
        const rodoHiddenElement = document.querySelector('.rodo-hidden-element');
        const rodoHiddenElementTrigger = document.querySelector('.rodo-hidden-element-trigger');
        rodoHiddenElementTrigger.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            rodoHiddenElement.classList.toggle('show');
            if (rodoHiddenElement.classList.contains('show')) {
                rodoHiddenElementTrigger.textContent = 'Zwiń';
            } else {
                rodoHiddenElementTrigger.textContent = 'Rozwiń więcej';
            }
            return false;
        });

        emailFormElement.addEventListener('submit', async (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (!validateEmail(emailInput.value)) {
                showInputError(emailInput, 'Wprowadź poprawny adres email');
                return;
            } else {
                clearInputError(emailInput);
            }

            if (!rodoConsent.checked) {
                showInputError(rodoConsent, 'Aby kontynuować zaznacz to pole');
                return;
            } else {
                clearInputError(rodoConsent);
            }

            const email = emailInput.value;
            const emailForm__generator = document.querySelector('.emailForm__generator');
            const emailForm__form = document.querySelector('.emailForm__form');
            emailForm__form.classList.add('hide');
            emailForm__generator.classList.add('show');

            // Build progress UI using DOM methods (safe, no innerHTML with user data)
            const progressContainer = document.createElement('div');
            progressContainer.className = 'report-progress';

            const barContainer = document.createElement('div');
            barContainer.className = 'report-progress__bar-container';
            const bar = document.createElement('div');
            bar.className = 'report-progress__bar';
            bar.id = 'reportProgressBar';
            bar.style.width = '0%';
            barContainer.appendChild(bar);

            const stepText = document.createElement('p');
            stepText.className = 'report-progress__step';
            stepText.id = 'reportProgressStep';
            stepText.textContent = 'Przygotowywanie...';

            const infoText = document.createElement('p');
            infoText.className = 'report-progress__info';
            infoText.textContent = 'Nie zamykaj tej strony. Raport zostanie wysłany na Twój email.';

            progressContainer.appendChild(barContainer);
            progressContainer.appendChild(stepText);
            progressContainer.appendChild(infoText);

            emailForm__generator.textContent = '';
            emailForm__generator.appendChild(progressContainer);

            // Start progress polling
            let progressInterval = null;
            const progressBar = document.getElementById('reportProgressBar');
            const progressStep = document.getElementById('reportProgressStep');

            progressInterval = setInterval(async () => {
                try {
                    const prog = await apiCall({ action: 'check_progress' }, 10000);
                    if (prog && prog.step) {
                        const pct = prog.percent || Math.round((prog.step / prog.total) * 100);
                        progressBar.style.width = pct + '%';
                        progressStep.textContent = 'Krok ' + prog.step + '/' + prog.total + ': ' + prog.message;
                    }
                } catch (e) {
                    // Pasek postepu to dodatek: klient nie dostaje komunikatu, a dziennik
                    // przyjmie tylko pierwszy taki blad (ten sam klucz nie wraca).
                    zglosBlad(Object.assign({ etap: 'check_progress' }, opiszBlad(e)));
                }
            }, 1500);

            try {
                // Generowanie raportu (AI + PDF + mail) potrafi trwac >1 min - dlugi timeout
                const data = await apiCall({ action: 'save_email', email: email }, 180000);

                clearInterval(progressInterval);

                if (data.status === 'ok') {
                    progressBar.style.width = '100%';

                    // Meta Pixel: TU jest prawdziwy lead - odbiorca zostawil adres.
                    zdarzenieMeta('Lead', {
                        content_name: document.getElementById('siteUrl2').textContent,
                        content_category: 'radar_ai',
                        status: true
                    });
                    pushDL('report_submitted', {
                        audit_query: document.getElementById('siteUrl2').textContent
                    });

                    // Naglowek i akapit zachety sa juz nieaktualne po wyslaniu -
                    // zostaje sam komunikat (ten sam mechanizm co localone-audytor).
                    document.querySelectorAll('.finally-results__intro').forEach((el) => el.remove());

                    // Jedno brzmienie komunikatu na trzech narzedziach (23.08.2026):
                    // radar konczyl na samym potwierdzeniu, audytory mialy juz zapowiedz
                    // kontaktu z 20.08. Teraz wszystkie trzy mowia to samo.
                    const successMsg = document.createElement('p');
                    successMsg.className = 'success-message';
                    successMsg.textContent = 'Raport został wysłany na Twój adres e-mail.';

                    const nextStep = document.createElement('p');
                    nextStep.className = 'success-next';
                    nextStep.textContent = 'Odezwiemy się z krótkim podsumowaniem: co z tej listy zrobić najpierw. Bez zobowiązań.';

                    emailForm__generator.textContent = '';
                    emailForm__generator.appendChild(successMsg);
                    emailForm__generator.appendChild(nextStep);
                } else {
                    const odmowa = new Error(data.message || 'Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie.');
                    odmowa.name = 'OdmowaSerwera';
                    throw odmowa;
                }
            } catch (error) {
                clearInterval(progressInterval);
                emailForm__form.classList.remove('hide');
                emailForm__generator.classList.remove('show');
                // 24.09.2026: przegladarka pokazywala surowe "signal is aborted without
                // reason" (limit czasu) albo "Failed to fetch" (zerwane polaczenie).
                // Klient dostaje zdanie po polsku; komunikaty serwera (OdmowaSerwera
                // z data.message) sa juz po polsku, przechodza bez zmian i serwer
                // zapisal je w dzienniku sam.
                const komunikat = error && error.name === 'OdmowaSerwera'
                    ? error.message
                    : obsluzBlad('save_email', error, 'Przygotowanie raportu trwa dłużej niż zwykle. Jeśli w ciągu kilku minut nie dostaniesz maila, wyślij formularz jeszcze raz albo napisz na marcin@avangardo.pl.');
                showInputError(emailInput, komunikat);
            }
        });

        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }

        function showInputError(inputElement, message) {
            const formGroup = inputElement.closest('.form-group');
            const errorElement = formGroup.querySelector('.error-msg');
            errorElement.textContent = message;
            formGroup.classList.add('has-error');
        }

        function clearInputError(inputElement) {
            const formGroup = inputElement.closest('.form-group');
            const errorElement = formGroup.querySelector('.error-msg');
            errorElement.textContent = '';
            formGroup.classList.remove('has-error');
        }
    }

    // Odnosnik do zapisanego wyniku: rysujemy go od razu, formularz zostaje pod spodem.
    try {
        const tokenWejscia = new URLSearchParams(window.location.search).get('r');
        if (tokenWejscia !== null) {
            wczytajRaport(tokenWejscia.trim().toLowerCase());
        }
    } catch (e) {
        // Stara przegladarka bez URLSearchParams: zostaje zwykly formularz, bez komunikatu.
        zglosBlad(Object.assign({ etap: 'wejscie_z_odnosnika' }, opiszBlad(e)));
    }

    function displayError(message) {
        clearError();
        const errorElement = document.createElement('p');
        errorElement.textContent = message;
        errorElement.classList.add('error-message');
        form.appendChild(errorElement);
    }

    function clearError() {
        const errorElement = form.querySelector('.error-message');
        if (errorElement) {
            form.removeChild(errorElement);
        }
    }

    function updatePreloaderData(newValue, duration = 500) {
        const currentValue = parseInt(preloaderData.textContent, 10) || 0;
        const steps = duration / 10; // 10 ms na krok
        const increment = (newValue - currentValue) / steps;

        let currentStep = 0;
        const interval = setInterval(() => {
            currentStep++;
            const value = Math.round(currentValue + increment * currentStep);
            preloaderData.textContent = `${value}%`;

            if (currentStep >= steps) {
                clearInterval(interval);
            }
        }, 10); // 10 ms na krok
    }
}
